export default {"src":"/_next/static/media/Experience.9f510677.svg","height":13,"width":14,"blurWidth":0,"blurHeight":0};